import { motion } from "framer-motion";
import { ArrowRight, Cake, Sandwich, Gift } from "lucide-react";
import { BUSINESS, IMAGES } from "@/data/content";

const ORDERS = [
  { icon: Cake, label: "Torte di compleanno", note: "E per ogni occasione speciale" },
  { icon: Sandwich, label: "Buffet salato", note: "Pizzette, panini, focacce farcite e tramezzini per eventi" },
  { icon: Gift, label: "Creazioni su misura", note: "Vassoi e idee personalizzate" },
];

export default function GlutenFree() {
  return (
    <section
      id="ordinazioni"
      className="bg-[#FDFBF7] py-16 sm:py-20"
      data-testid="ordinazioni-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-2xl overflow-hidden bg-[#8C9B86] text-[#1A2017]"
        >
          <div className="grid lg:grid-cols-2 items-stretch">
            <div className="p-8 sm:p-14 lg:p-16 flex flex-col justify-center">
              <span className="inline-flex items-center gap-2 self-start rounded-full bg-[#1A2017]/10 px-4 py-1.5 mb-6">
                <span className="font-body text-xs tracking-[0.2em] uppercase font-semibold">
                  Su ordinazione
                </span>
              </span>
              <h2 className="font-display font-light tracking-tight leading-[0.95] text-[clamp(2.5rem,6vw,4.5rem)]">
                Ordina quello
                <br />
                <span className="italic">che desideri.</span>
              </h2>
              <p className="mt-6 font-body text-base sm:text-lg leading-relaxed max-w-md text-[#1A2017]/85">
                Dalle torte di compleanno ai buffet con pizzette, panini,
                focacce farcite e tramezzini, fino alle creazioni
                personalizzate: prepariamo tutto su ordinazione, con la stessa
                cura artigianale di sempre.
              </p>

              <div className="mt-8 grid sm:grid-cols-2 gap-4 max-w-lg">
                {ORDERS.map((o) => (
                  <div
                    key={o.label}
                    className="flex items-start gap-3"
                    data-testid={`order-type-${o.label}`}
                  >
                    <span className="mt-0.5 shrink-0 grid place-items-center h-9 w-9 rounded-full bg-[#1A2017]/10">
                      <o.icon size={17} />
                    </span>
                    <div>
                      <div className="font-body font-semibold text-sm">{o.label}</div>
                      <div className="font-body text-xs text-[#1A2017]/70">{o.note}</div>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href={BUSINESS.phoneHref}
                className="mt-9 group inline-flex items-center gap-2 self-start rounded-full bg-[#1A2017] text-[#FDFBF7] px-7 py-4 font-body font-semibold text-sm hover:bg-[#2A1B14] transition-all duration-300 hover:scale-[0.98]"
                data-testid="order-btn"
              >
                Ordina ora · {BUSINESS.phone}
                <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>

            <div className="relative min-h-[280px] lg:min-h-full">
              <img
                src={IMAGES.pastries}
                alt="Creazioni personalizzate su ordinazione"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#8C9B86]/60 to-transparent lg:from-[#8C9B86]/40" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
